module.exports = __webpack_public_path__ + "static/media/logo.2208f87d.svg";